import { format, parse, distanceInWordsStrict } from 'date-fns'
import ru from 'date-fns/locale/ru'
import { getVatText } from '@/components/SelectVat'
import { getUnitText, getUnit1000Text } from '@/components/SelectUnit'
import _semver from 'semver'

// Можно ли использовать Intl.NumberFormat
const isNumberFormatAvailable = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function')

export const date = (value, f = 'DD.MM.YYYY') => {
    let date = parse(value)

    return !isNaN(date.getTime())
        ? format(value, f)
        : null
}

export const datetime = (value, f = 'DD.MM.YYYY HH:mm:ss') => {
    let date = parse(value)

    return !isNaN(date.getTime())
        ? format(value, f)
        : null
}

export const money = value => isNumberFormatAvailable
    ? new Intl.NumberFormat('ru-RU', { style: 'decimal' }).format(value)
    : value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ')

export const timeago = (value) => {
    let date = parse(value)

    return !isNaN(date.getTime())
        ? distanceInWordsStrict(new Date(), date, { addSuffix: true, locale: ru })
        : null
}

export const paymentType = (value) => {
    return value === 1 ? 'Нал' : 'Безнал'
}

export const nodata = (value) => {
    return (value === null || value === undefined) ? 'N/A' : value
}

const currencies = {
    '643': { symbol: '₽' },
    '840': { symbol: '$' },
    '978': { symbol: '€' }
}

export const currencySymbol = (value) => {
    return currencies[value] ? currencies[value].symbol : value
}

const companyStates = {
    '1': { text: 'ОК' },
    '2': { text: 'ОК' },
    '3': { text: 'Фин. блокировка' },
    '4': { text: 'Бан' }
}

export const companyStateText = (value) => {
    return companyStates[value] ? companyStates[value].text : value
}

const billTxTypes = {
    '1': { text: 'Зачисление' },
    '2': { text: 'Списание' }
}

export const billTxTypeText = (value) => {
    return billTxTypes[value] ? billTxTypes[value].text : value
}

const billTxSubtypes = {
    '1': { text: 'Ежемесячный платеж' },
    '2': { text: 'Коррекция' },
    '3': { text: 'Онлайн платеж' }
}

export const unit = (value) => {
    return getUnitText(value)
}

export const unit1000 = (value) => {
    return getUnit1000Text(value)
}

export const vat = (value) => {
    return getVatText(value)
}

export const billTxSubtypeText = (value) => {
    return billTxSubtypes[value] ? billTxSubtypes[value].text : value
}

export const semver = value => value && _semver.coerce(value)

export const makeApiUrl = value => {
    if (typeof value !== 'string' || !value.length) {
        return value
    }

    if (value.charAt(0) === '/') {
        value.slice(0, 1)
    }

    return `${process.env.VUE_APP_API_URL}/${value}`
}

export default {
    date,
    datetime,
    money,
    timeago,
    nodata,
    paymentType,
    currencySymbol,
    companyStateText,
    billTxTypeText,
    billTxSubtypeText,
    unit,
    vat,
    semver,
    makeApiUrl
}
